module.exports = __webpack_public_path__ + "img/Popup Alert-Warning0.d2b8a014.png";